<template>
  <ListItem>
    <div class="flex items-start gap-x-3">
      <p class="text-sm font-semibold leading-6 text-surface-900" v-if="showSerialNumber">
        {{ log.device?.serial_number ?? $t('common.na') }}
      </p>
      <FlatBadge :color="statuses[log.status]" :value="log.status" :class="{
        'mt-0.5': showSerialNumber,
      }"/>
    </div>

    <div class="mt-1 text-xs leading-5 text-surface-500">
      <div v-if="showDeviceType">
        {{ getSubHeading || $t('common.na') }}
      </div>
      <ValueChange :from="log.current_firmware?.version_number" :to="log.target_firmware?.version_number"/>
      <div class="flex flex-row justify-between items-center space-x-2 w-full" v-if="showInitiatedBy || showInitiatedAt">
        <span class="text-surface-800 flex-1 font-medium" v-if="showInitiatedBy">{{ log.initiated_by?.name || $t('common.na') }}</span>
        <span class="text-surface-400" v-if="showInitiatedAt"><time>{{ $d(Date.parse(log.initiated_at), 'long') }}</time></span>
      </div>
    </div>

    <template #menu>
      <Button
          type="button"
          @click="toggle($event)"
          severity="secondary"
          size="small"
          text
          aria-haspopup="true"
          aria-controls="overlay_menu"
      >
        <template #icon>
          <IconDots/>
        </template>
      </Button>

      <Menu
          ref="menu"
          id="overlay_menu"
          :popup="true"
          :model="[
					  { label: this.$t('common.details'), icon: 'IconEye', command: (e) => { this.$emit('on-show', log)} },
				  ]"
      >
        <template #itemicon="{ item, class: iconClass }">
          <component v-if="item.icon" :is="item.icon" class="mr-2" :class="iconClass"/>
        </template>
      </Menu>
    </template>
  </ListItem>
</template>

<script>
import ListItem from "@/Components/ListItem.vue";
import {IconDots, IconEye} from "@tabler/icons-vue";
import FlatBadge from "@/Components/Badges/FlatBadge.vue";
import ValueChange from "@/Components/ValueChange.vue";

export default {
  name: "DevicesBeingUpdatedListItem",
  emits: ['on-show'],
  data() {
    return {
      statuses: {
        'PENDING': 'surface',
        'INITIATED': 'yellow',
        'COMPLETE': 'green',
        'FAILED': 'red',
      }
    }
  },
  props: {
    log: {
      type: Object,
      required: true,
    },
    showDeviceType: {
      type: Boolean,
      default: true,
    },
    showDeviceModel: {
      type: Boolean,
      default: true,
    },
    showDeviceRevision: {
      type: Boolean,
      default: true,
    },
    showSerialNumber: {
      type: Boolean,
      default: true,
    },
    showInitiatedAt: {
      type: Boolean,
      default: true,
    },
    showInitiatedBy: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    ValueChange,
    IconDots,
    FlatBadge,
    IconEye,
    ListItem,
  },
  methods: {
    toggle($event) {
      this.$refs.menu.toggle($event);
    }
  },
  computed: {
    getSubHeading(){
      return [
        this.showDeviceType ? this.log.device?.device_type?.name : null,
        this.showDeviceModel ? this.log.device?.device_model?.name : null,
        this.showDeviceRevision ? this.log.device?.device_revision?.name : null,
      ].filter(_ => _ !== null).join(' / ');
    }
  },
}
</script>

<style scoped>

</style>
